import { UseMutateFunction } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { UploadedFile } from 'web-library/models/UploadedFile';
import { putUploadFileToS3 } from '../../../../../../api/candidate/access-arrangement/@candidate/api-services/api';

/** put uploaded document to S3 service
 * */
export const uploadToPresignLink = async (presignLink: string, key: string, uploadFile: File) => {
  try {
    const s3FormData = new FormData();
    s3FormData.append(key, uploadFile, key);
    console.log(import.meta.env.PROD);
    console.log('true:', import.meta.env.PROD);
    const response = await putUploadFileToS3(
      import.meta.env.PROD ? uploadFile : s3FormData,
      presignLink
    );
    return Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getInitialFiles = (files: UploadedFile[]) => {
  const initialFiles = files.map((file) => file.file);
  return initialFiles;
};

export const handleFileDelete = (
  file: File,
  files: UploadedFile[],
  setFiles: (files: UploadedFile[]) => void,
  deleteFileMutate: UseMutateFunction<AxiosResponse | void, AxiosError, string>
) => {
  const fileIndex = files.findIndex((f) => f.file.name === file.name && f.file.size === file.size);
  const fileToDelete = files[fileIndex];
  if (fileToDelete && fileToDelete.key) {
    deleteFileMutate(fileToDelete.key);
  }
  if (fileIndex >= 0) {
    const newFiles = [...files];
    newFiles.splice(fileIndex, 1);
    setFiles(newFiles);
  }
};
